"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12.34 4.133a.5.5 0 0 0-.68 0l-6.5 6A.5.5 0 0 0 5.5 11H7v4h-.5a.5.5 0 0 0-.5.5V17h-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5H18v-1.5a.5.5 0 0 0-.5-.5H17v-4h1.5a.5.5 0 0 0 .34-.867zM8 15v-4h2v4zm3 0v-4h2v4zm3 0v-4h2v4z"
}), 'BankFilled');
//# sourceMappingURL=index.js.map